export default {
	common: {
		status: 'Status',
		enabled: 'Enabled',
		disabled: 'Disabled',
		internal: 'Internal',
		public: 'Public',
		please_select: 'Please select ...',
		no_data_available: 'No data available',
		leave_blank_to_keep: 'Leave blank to keep the existing value',
	},
	app: {
		asterisk: {
			reload: 'Reload Asterisk',
			reload_confirm: 'Do you want to apply the changes on the Asterisk server by reloading it immediately?',
			reload_success: 'Asterisk reloaded successfully',
		},
		pjsip: {
			contexts: {
				aor: 'AoR',
				auth: 'Authentication',
				endpoint: 'Endpoint',
				registration: 'Registration',
			},
		},
	},
	filter_by: {
		extension: 'Filter by Extension',
		phone: 'Filter by Phone',
		ring_group: 'Filter by Ring Group',
		shortcut_button: 'Filter by Shortcut Button',
		team: 'Filter by Team',
		trunk: 'Filter by Trunk',
		user: 'Filter by Name',
	},
	sidebar: {
		header_me: 'Welcome, {firstname}!',
		header_admin: 'Admin Settings',
		my_dashboard: 'Dashboard',
		my_voicemail: 'My Voicemail',
		my_phonebook: 'My Phonebook',
		my_call_history: 'My Call History',
		header_manage: 'Manage Team: {team}',
		phones: 'Phones',
		extensions: 'Extensions',
		ring_groups: 'Ring Groups',
		shortcut_buttons: 'Shortcut Buttons',
		trunks: 'Trunks',
		phonebook: 'Phonebook',
		call_records: 'Call Records',
		global_phonebook: 'Global Phonebook',
	},
	pages: {
		my: {
			dashboard: {
				extensions_title: 'My Extensions',
			},
			phonebook: {
				title: 'My Phonebook',
				actions: {
					download: 'Download Phonebook as VCF/vCard file',
					dial: 'Dial number',
				},
			},
			voicemail: {
				title: 'My Voicemail',
				subtitle: '{new_count} new message(s), {total_count} total message(s)',
				actions: {
					play: 'Play voicemail',
					stop: 'Stop voicemail',
					download: 'Download audio file',
					delete: 'Delete',
				},
				confirm_delete: 'Are you sure you want to delete the voicemail from {number}?',
				delete_successful: 'Voicemail successfully deleted',
			},
			call_records: {
				title: 'My Call Records',
			},
		},
		me: {
			asterisk_settings: {
				title: 'Asterisk Settings',
				description: 'Settings for the Asterisk integration',
				ask_reload: 'Ask to reload Asterisk after changes',
			},
		},
		phones: {
			title: 'Phones: {team_name}',
			entry_created: 'Phone {name} was created',
			entry_updated: 'Phone {name} was updated',
			entry_deleted: 'Phone {name} was deleted',
			copy_initial_sync_url_success: 'Copied initial sync URL into your clipboard',
			provisioning_psk_reset: 'PSK for phone {phone_name} ({phone_identifier}) successfully reset',
			phone_resynced: 'Phone {phone_name} ({phone_identifier}) resynced',
			phone_restarted: 'Phone {phone_name} ({phone_identifier}) restarted',
			actions: {
				edit: 'Edit Phone',
				reset_psk: 'Reset configuration PSK',
				restart: 'Restart snom phone',
				resync: 'Re-sync snom phone configuration',
			},
			confirm: {
				reset_psk: {
					title: 'Reset phone PSK: {phone_name} ({phone_identifier})',
					body: 'Are you sure you want to reset the configuration PSK for the phone {phone_name} ({phone_identifier})? You might need to reset the phone before it can synchronize its settings agian!',
				},
				restart_phone: {
					title: 'Restart phone: {phone_name} ({phone_identifier})',
					body: 'Are you sure you want to restart the phone {phone_name} ({phone_identifier})? This action will drop active calls!',
				},
			},
		},
		extensions: {
			title: 'Extensions: {team_name}',
			entry_created: 'Extension {name} was created',
			entry_updated: 'Extension {name} was updated',
			entry_deleted: 'Extension {name} was deleted',
			reset_sip_auth: {
				title: 'Reset SIP authentication data',
				confirm:
					'Are you sure you want to reset the SIP authentication data for the extension {number}, {callerid}? This phone will not be able to communicate with the server until its configuration has updated, either automatically or manually!',
				failed: 'Failed to reset SIP authentication data for the extension {number}, {callerid}: {error}',
			},
			actions: {
				edit: 'Edit Extension',
				reset_sip_auth: 'Reset SIP authentication data',
				show_sip_auth: 'Show SIP authentication data',
			},
		},
		ring_groups: {
			title: 'Ring Groups: {team_name}',
			entry_created: 'Ring Group {name} was created',
			entry_updated: 'Ring Group {name} was updated',
			entry_deleted: 'Ring Group {name} was deleted',
			actions: {
				edit: 'Edit Ring Group',
			},
		},
		shortcut_buttons: {
			title: 'Shortcut Buttons: {team_name}',
			entry_created: 'Shortcut Button {index} was created',
			entry_updated: 'Shortcut Button {index} was updated',
			entry_deleted: 'Shortcut Button {index} was deleted',
			actions: {
				edit: 'Edit Shortcut Button',
			},
		},
		trunks: {
			title: 'Trunks',
			entry_created: 'Trunk {name} was created',
			entry_updated: 'Trunk {name} was updated',
			entry_deleted: 'Trunk {name} was deleted',
			actions: {
				edit: 'Edit Trunk',
			},
		},
		phonebook: {
			title: 'Phonebook: {team_name}',
			entry_created: 'Phonebook Entry {name} was created',
			entry_updated: 'Phonebook Entry {name} was updated',
			entry_deleted: 'Phonebook Entry {name} was deleted',
			actions: {
				edit: 'Edit Phonebook Entry',
			},
		},
		call_records: {
			title: 'Call Records',
			no_callerid: 'No CallerID',
			toggle_debugging: 'Toggle debugging mode',
			forwarded_to: '(forwarded to {forwarded_to})',
		},
	},
	modals: {
		configure_call_forwarding: {
			title: 'Configure Forwarding',
			text: 'Please enter the number you want to forward calls to or leave the field empty to disable forwarding:',
			ooo_enabled_warning:
				'Warning: Out-of-Office is currently enabled for this extension. To configure and enable call forwarding, please disable Out-of-Office first!',
		},
		edit_phone: {
			create_title: 'Create new Phone',
			edit_title: 'Edit Phone',
			confirm_delete: 'Are you sure you want to delete the phone {name}?',
			sections: {
				basics: {
					title: 'Basic Settings',
				},
				assignments: {
					title: 'Assignments',
				},
			},
		},
		edit_extension: {
			create_title: 'Create new Extension',
			edit_title: 'Edit Extension',
			confirm_delete: 'Are you sure you want to delete the extension {name}?',
			sections: {
				basics: {
					title: 'Basic Settings',
				},
				forwarding: {
					title: 'Call Forwarding and Out-of-Office',
					enter_target: 'To external target',
					select_target: 'Or to local Extension',
				},
				voicemail: {
					title: 'Voicemail',
				},
				miscellaneous: {
					title: 'Miscellaneous',
				},
			},
		},
		edit_ring_group: {
			create_title: 'Create new Ring Group',
			edit_title: 'Edit Ring Group',
			confirm_delete: 'Are you sure you want to delete the ring group {name}?',
			sections: {
				basics: {
					title: 'Basic Settings',
				},
				extensions: {
					title: 'Assigned Extensions',
				},
			},
		},
		edit_shortcut_button: {
			create_title: 'Create new Shortcut Button',
			edit_title: 'Edit Shortcut Button',
			confirm_delete: 'Are you sure you want to delete the shortcut button {index}?',
		},
		edit_trunk: {
			create_title: 'Create new Trunk',
			edit_title: 'Edit Trunk',
			confirm_delete: 'Are you sure you want to delete the trunk {name}?',
			sections: {
				basics: {
					title: 'Basic Settings',
				},
				sip: {
					title: 'SIP Settings',
				},
			},
		},
		edit_phonebook_entry: {
			create_title: 'Create Phonebook Entry',
			edit_title: 'Edit Phonebook',
			confirm_delete: 'Are you sure you want to delete the phonebook entry {name}?',
		},
		show_sip_auth_data: {
			title: 'Show SIP authentication data',
			text: 'SIP authentication data for {callerid}, {number}',
		},
	},
	models: {
		extension: {
			slug: 'Slug',
			number: 'Extension No.',
			caller_id: 'Caller ID',
			internal_only: 'Internal Only',
			sip_username: 'SIP Username',
			sip_password: 'SIP Password',
			voicemail_active: 'Voicemail Active?',
			voicemail_password: 'Voicemail Password',
			primary_trunk: 'Primary Trunk',
			user: 'User',
			team: 'Team',
			trunk: 'Trunk',
			phones: 'Phones',
			ring_groups: 'Ring Groups',
			pjsip_extra_config: 'Extra PJSIP Configuration',
			out_of_office: 'Out-of-Office',
			forward_to: 'Forward Calls to',
			aliases: 'Aliases',
			transport: 'Transport',
			status: 'Status',
			active_channel_count: 'Active Channel Count',
			statuses: {
				offline: 'Offline',
				online: 'Online',
				unknown: 'Unknown',
			},
			forwarding_mode: {
				out_of_office: 'Out-of-Office',
				forwarded_to: 'Forwarded to {number}',
				available: 'Available',
			},
			status_icon: '',
			actions: 'Actions',
		},
		alias: {
			aliasable: 'Alias Parent',
			trunk: 'Trunk',
			number: 'Number',
		},
		phone: {
			slug: 'Slug',
			name: 'Name',
			identifier: 'Identifier',
			location: 'Location',
			enabled: 'Enabled',
			last_provision_attempt: 'Last provision attempt',
			last_successful_provision: 'Last successful provision',
			last_provision_status: 'Last status',
			last_provision_source_ip: 'Last provision attempt source IP',
			type: 'Type',
			team: 'Team',
			user: 'User',
			extensions: 'Extensions',
			phone_type: 'Phone Type',
			shortcut_buttons: 'Shortcut Buttons',
			shortcut_buttons_hint: 'Select either an Extension or specify display title and target number manually',
			status: '',
			actions: 'Actions',
			provision_status: {
				unknown: 'No previous provisioning attempt or unknown status',
				not_configured: 'Phone is not configured for provisioning',
				already_provisioned: 'Provisioned phone reusing initial provision URL',
				invalid_psk: 'Invalid PSK provided',
				initial_ok: 'Initial provisioning OK',
				update_ok: 'Update provisioning OK',
			},
		},
		ring_group: {
			name: 'Name',
			number: 'Extension No.',
			internal_only: 'Internal Only',
			team: 'Team',
			extensions: 'Extensions',
			actions: 'Actions',
			aliases: 'Aliases',
			targets: 'Targets',
			external_numbers: {
				name: 'External Targets',
				number: 'Phone Number',
			},
		},
		trunk: {
			name: 'Name',
			description: 'Description',
			prefixes: 'Prefixes',
			inbound_prefix: 'Inbound Prefix',
			outbound_prefix: 'Outbound Prefix',
			shorthand_prefix: 'Shorthand/Internal Prefix',
			prefix_size: 'Prefix Size',
			sip_server_uri: 'SIP Server URI',
			sip_client_uri: 'SIP Client URI',
			sip_username: 'SIP Username',
			sip_password: 'SIP Password',
			pjsip_extra_config: 'PJSIP Extra Configuration',
			aliases: 'Aliases',
			team: 'Team',
			enabled: 'Enabled',
			sip_data: 'SIP Data',
			actions: 'Actions',
		},
		phonebook_entry: {
			number: 'Phone Number',
			name: 'Contact Name',
			type: 'Phone Number Type',
			team: 'Associated Team',
			user: 'Associated User',
			actions: 'Actions',
			types: {
				CELL: 'Work (Cellular)',
				WORK: 'Work (Landline)',
				HOME: 'Personal',
				PREF: 'Preferred',
				VOICE: 'Other (Non-Fax)',
			},
		},
		asterisk_cdr: {
			caller: 'Caller',
			callee: 'Callee',
			direction: 'Direction',
			source_number: 'Caller Phone No.',
			source_callerid: 'CallerID',
			destination_number: 'Callee Phone No.',
			call_start: 'Started at',
			call_answered: 'Answered at',
			call_end: 'Ended at',
			call_duration: 'Total Duration',
			dial_context: 'Dial Context',
			last_dialplan_app: 'Last Dialplan App',
			last_dialplan_app_data: 'App Data',
			linkedid: 'Linked ID',
			sequence: 'Sequence ID',
			forwarded_to: 'Forwarded To',
			call_status: 'Status',
			call_statuses: {
				NOANSWER: 'Not answered',
				CHANUNAVAIL: 'Callee not available',
				VOICEMAIL: 'Voicemail answered',
				ANSWERED: 'Callee answered',
				QUEUE_TIMEOUT: 'Queue timed out',
				INVALID: 'Number invalid',
				BUSY: 'Callee was busy',
				OUT_OF_OFFICE: 'Callee was out-of-office',
				CANCEL: 'Call was cancelled by the caller',
			},
		},
		asterisk_voicemail_message: {
			caller_number: 'Caller Number',
			caller_name: 'Caller Name',
			extension: 'Destination Extension',
			origtime: 'Recorded at',
			duration: 'Recording Duration',
			status_icon: '',
			actions: '',
		},
		pjsip_extra_config: {
			context: 'Context',
			key: 'Key',
			value: 'Value',
		},
		team: {
			name: 'Team Name',
			prefix_size: 'Internal Prefix Size',
			internal_prefix: 'Internal Prefix',
			primary_trunk: 'Primary Trunk',
			phone_admin_password: 'Phone Admin Password',
		},
		shortcut_button: {
			index: 'Index',
			extension: 'Local Extension Target',
			title: 'Button Title',
			target: 'External Number Target',
			actions: 'Actions',
		},
		team_voicemail_email_config: {
			subject: 'Message Subject',
			date_format: 'Date Format',
			body: 'Message Body',
		},
	},
	tabs: {
		me: {
			asterisk_settings: 'Asterisk Settings',
		},
		team_settings: {
			general: 'Team Settings',
			voicemail: 'Voicemail Settings',
			voicemail_messages: {
				asterisk_variables_hint: 'For available variables to use in the e-mail header or body, see {0}.',
			},
			users: 'Members',
		},
	},
	components: {
		userExtensionCard: {
			configure: 'Configure Extension',
			status: {
				busy: 'Busy',
				out_of_office: 'Out of office',
				forwarding: 'Forwarding calls',
				online: 'Available',
				offline: 'Offline',
				unknown: 'Unknown',
			},
		},
	},
};
